import * as React from "react";
import { WmkLink } from "wmk-link";
import styled from "styled-components";
import { FaAngleRight } from "react-icons/fa";
import { Tag } from "wmk-tag";
import { MediaItem } from "../classes/Media";
import { colors } from "../../../ui/colors";
import { MediaTypes } from "../../../../node/mediaTag";

const Wrap = styled.div`
  padding: 0 0 1rem 0;
  display: flex;
  * {
    margin-right: 7px;
    font-size: 0.9rem;
    font-weight: 300;
  }
  button,
  a {
    border: none;
    background: none;
    height: 1.1rem;
    padding: 0;
    color: ${colors.orange.toString()};
    text-decoration: none;
    &:hover {
      color: ${colors.blue.toString()};
      text-decoration: underline;
    }
  }
  span {
    color: ${colors.teal.toString()};
  }
  img {
    width: 10px;
    height: 15px;
    position: relative;
    top: 2px;
  }
`;

const Separator = () => (
  <span style={{ color: colors.blue.toString() }}>
    <FaAngleRight />
  </span>
);

export const basePath = `/resources/media`;

export const Breadcrumbs = ({
  currCat,
  type,
  currMedia
}: {
  currCat?: Tag;
  type?: MediaTypes;
  currMedia?: MediaItem;
}) => {
  const _type = type && type[0]?.toLocaleUpperCase() + type.substring(1);
  return type ? (
    <Wrap>
      {/* <WmkLink to="/">
        Home
      </WmkLink>
      <Separator />
      <WmkLink to={`/resources`}>Resources</WmkLink>
      <Separator /> */}
      <WmkLink to={basePath}>Media Gallery</WmkLink>
      {type ? (
        currCat || currMedia ? (
          <>
            <Separator />
            <WmkLink to={`${basePath}/${type}`}>{_type}</WmkLink>
          </>
        ) : (
          <>
            <Separator />
            <span>{_type}</span>
          </>
        )
      ) : null}
      {currCat ? (
        <>
          <Separator />
          <span>{currCat.name}</span>
        </>
      ) : null}
      {currMedia && (
        <>
          <Separator />
          <span>{currMedia.title}</span>
        </>
      )}
    </Wrap>
  ) : null;
};
